<template>
  <div class="lang-switcher">
    <!-- <span class="single-lang caption" @click="changeLanguage('en')" :class="currentLang == 'en' ? 'active' : ''">EN</span>
    <span class="single-lang caption" @click="changeLanguage('de')" :class="currentLang == 'de' ? 'active' : ''">DE</span>
    <span class="single-lang caption" @click="changeLanguage('fr')" :class="currentLang == 'fr' ? 'active' : ''">FR</span>
    <span class="single-lang caption" @click="changeLanguage('es')" :class="currentLang == 'es' ? 'active' : ''">ES</span>
    <span class="single-lang caption" @click="changeLanguage('ga')" :class="currentLang == 'ga' ? 'active' : ''">GA</span>
    <span class="single-lang caption" @click="changeLanguage('hu')" :class="currentLang == 'hu' ? 'active' : ''">HU</span>
    <span class="single-lang caption" @click="changeLanguage('is')" :class="currentLang == 'is' ? 'active' : ''">IS</span>
    <span class="single-lang caption" @click="changeLanguage('ru')" :class="currentLang == 'ru' ? 'active' : ''">RU</span> -->
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      langs: ['English', 'German'],
      currentLang: 'en',
      languages: [
        {
          title: 'English',
          value: 'en'
        },
        {
          title: 'Deutsche',
          value: 'de'
        },
        {
          title: 'Gaeilge',
          value: 'ga'
        },
        {
          title: 'Magyar',
          value: 'hu'
        },
        {
          title: 'Íslensku',
          value: 'is'
        },
        {
          title: 'Español',
          value: 'es'
        },
        {
          title: 'Français',
          value: 'fr'
        },
        {
          title: 'русский',
          value: 'ru'
        }
      ]
    }
  },
  mounted() {
    if (localStorage.getItem('language')) {
      const startLang = JSON.parse(localStorage.getItem('language'))
      this.$i18n.locale = startLang
      this.currentLang = startLang
    } else {
      this.$i18n.locale = 'en'
      this.currentLang = 'en'
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang
      this.currentLang = lang
      localStorage.setItem('language', JSON.stringify(lang))
    }
  }
}
</script>

<style lang="scss">
.switcher {
  width: 200px;
  float: right;
}

.language {
  padding-left: 10px;
}
.single-lang {
  display: inline-block;
  padding: 0 10px;
  &:hover {
    cursor: pointer;
  }
  &.active {
    background-color: white;
    padding: 4px;
    border-radius: 8px;
    color: black;

  }
}

</style>
